import { inject, provide } from "vue"
import type { Ref } from "vue"

export interface ActivityIndicatorData {
    unreadCount: number
    pendingModerationCount: number
}

export interface AppContextData {
    communityIndicator: Ref<ActivityIndicatorData>
}

const AppContextKey = Symbol('AppContext')

export function provideAppContext(data: AppContextData) {
    provide(AppContextKey, data)
}

export function useAppContext(): AppContextData {
    const data = inject(AppContextKey)

    if (!data) {
        throw new Error('AppContext missing')
    }

    return data as AppContextData
}
